<template>
    <!-- 轮播图 -->
    <div id="myCarousel" class="carousel slide" data-ride="carousel">

        <div class="carousel-inner">

            <div class="carousel-item active">
                <div class="bd-banner-img bd-banner-img1"></div>

                <div class="container">
                    <div class="carousel-caption textBox">
                        <h3 id="box1H3Id">产&nbsp;融&nbsp;数&nbsp;科</h3>
                        <h1 class="font-weight-bolder" id="bigTitle01">
                            <span style='color: #ccad72;'>产&nbsp;融&nbsp;数&nbsp;科</span>
                            &nbsp;金&nbsp;融&nbsp;服&nbsp;务&nbsp;平&nbsp;台
                        </h1>
                        <p id="box1PId"><span>用数据创造财富 &nbsp;&nbsp;&nbsp;&nbsp; 让信用产生价值 </span></p>
                    </div>
                </div>
            </div>

            <div class="carousel-item">
                <div class="bd-banner-img bd-banner-img2"></div>
                <div class="container">
                    <div class="carousel-caption textBox">
                        <h3 id="box2H3Id">百亿资金支持企业复工复产</h3>
                        <h1 class="font-weight-bolder" id="bigTitle02">
                            <span style='color: #ccad72;'>产&nbsp;融&nbsp;数&nbsp;科</span>
                            &nbsp;科&nbsp;创&nbsp;金&nbsp;融&nbsp;服&nbsp;务&nbsp;在&nbsp;行&nbsp;动&nbsp;
                        </h1>
                        <p><span style="color:#FFFFFF">政策引领、数字赋能、变不可能为可能</span></p>
                    </div>
                </div>
            </div>

            <div class="carousel-item">

                <div class="bd-banner-img bd-banner-img3"></div>

                <div class="container">
                    <div class="carousel-caption textBox">
                        <h1 class="font-weight-bolder" id="bigTitle03">热列庆祝<span style='color: #ccad72;'>产融数科</span>科创平台启动运营
                        </h1>
                        <br />
                        <!-- <h3 id="box3H3Id">山东省财政厅主导打造</h3> -->
                        <p><span style="color: #FFFFFF;">山东省科学院、山东省投融资担保集团有限公司、山东省信用金桥等专业机构倾力开发运营</span></p>
                    </div>
                </div>
            </div>

        </div>


        <div>
            <button class="carousel-control-prev" type="button" data-target="#myCarousel" data-slide="prev">
                <div class="banner60">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </div>
            </button>

            <button class="carousel-control-next" type="button" data-target="#myCarousel" data-slide="next">
                <div class="banner60">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </div>
            </button>

        </div>

    </div>
</template>

<script>

export default {
    name: "Banner",
    methods: {

    },
}
</script>

<style scoped>
@font-face {
    font-family: '得意黑';
    src: url('../../assets/font/SmileySans-Oblique-2.ttf');
    font-weight: normal;
    font-style: normal;
}



.carousel {
    margin-bottom: 0rem;
}

/* 轮播图 */
.bd-banner-img {
    width: 1920px;
    height: 620px;
    background-size: 100%;
    float: left;
    background-repeat: no-repeat;

}

.bd-banner-img1 {
    background-image: url("../../assets/img/banner1.jpg");
}

.bd-banner-img2 {
    background-image: url("../../assets/img/banner2.jpg");
}

.bd-banner-img3 {
    background-image: url("../../assets/img/banner3.jpg");

}

.bd-banner-img4 {
    background-image: url("../../assets/img/banner4.jpg");
}

.carousel-inner {
    position: relative;
    width: 1920px;
    height: 737px; /* 占满整个屏幕 */
    overflow: hidden;
}

.textBox {
    width: 1200px;
    height: 240px;
}

.textBox h1 {
    padding-left: 100px;
    font-size: 80px;
}

.textBox p {
    color: #002785;
    font-weight: 700;
    margin-top: 25px;
    font-size: 25px;
}

.textBox h3 {
    font-size: 30px;
    font-family: '得意黑';
}

.textBox p span {
    margin-left: 100px;
    font-weight: 500;
    color: #002785;
    font-family: '得意黑';
}

.banner60 {
    width: 60px;
    height: 60px;
    padding-top: 20px;
    background: #837359;
}

#bigTitle01 {
    font-family: '得意黑';
}

#bigTitle02 {
    font-family: '得意黑';
}

#bigTitle03 {
    font-family: '得意黑';
}

#box2H3Id {
    margin-left: 80px;
}

#box1PId {
    margin-left: -20px;
}

#box1H3Id {
    margin-left: 80px;
}

#box3H3Id {
    margin-top: 20px;
    margin-left: 80px;
}</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/Banner.vue